import { AccessConflict, canRenderAccessConflict } from 'components/core/insights/insight-kinds/analysis/AccessConflict'
import { GrantsAccount, canRenderGrantsAccount } from 'components/core/insights/insight-kinds/analysis/GrantsAccount'
import { GrantsGlobal, canRenderGrantsGlobal } from 'components/core/insights/insight-kinds/analysis/GrantsGlobal'
import { GrantsManager, canRenderGrantsManager } from 'components/core/insights/insight-kinds/analysis/GrantsManager'
import { TaskValue } from 'lib/actions/task'
import {
    GlobalOutcome,
    AccountOutcome,
    ManagerOutcome,
    UserPropOutcome,
    AccessConflictOutcome,
} from 'pbts/c1/api/analysis/v1/analysis'
import { InsightType, AnalysisInsight } from 'pbts/c1/api/task/v1/insights'
import { Any } from 'pbts/google/protobuf/any'
import React, { FC } from 'react'
import { GrantsUser, canRenderGrantsUser } from './GrantsUser'

export type AnalysisProps = {
    analysis: AnalysisInsight
    insightType: InsightType
    showIcon?: boolean
    task: TaskValue
}

export const canRenderAnalysis = (analysis: AnalysisInsight): boolean => {
    const outcome = analysis.outcome
    switch (Any.typeUrlToName(outcome?.outcome?.typeUrl || '')) {
        case GlobalOutcome.typeName:
            return canRenderGrantsGlobal(outcome)
        case AccountOutcome.typeName:
            return canRenderGrantsAccount(outcome)
        case UserPropOutcome.typeName:
            return canRenderGrantsUser(outcome)
        case ManagerOutcome.typeName:
            return canRenderGrantsManager(outcome)
        case AccessConflictOutcome.typeName:
            return canRenderAccessConflict(outcome)
        default:
            return false
    }
}

export const Analysis: FC<AnalysisProps> = ({ analysis, insightType, showIcon = true, task }) => {
    switch (Any.typeUrlToName(analysis.outcome?.outcome?.typeUrl || '')) {
        case GlobalOutcome.typeName:
            return <GrantsGlobal outcome={analysis.outcome} insightType={insightType} showIcon={showIcon} />
        case AccountOutcome.typeName:
            return <GrantsAccount outcome={analysis.outcome} insightType={insightType} showIcon={showIcon} />
        case UserPropOutcome.typeName:
            return <GrantsUser outcome={analysis.outcome} insightType={insightType} showIcon={showIcon} />
        case ManagerOutcome.typeName:
            return <GrantsManager outcome={analysis.outcome} insightType={insightType} showIcon={showIcon} />
        case AccessConflictOutcome.typeName:
            return <AccessConflict outcome={analysis.outcome} insightType={insightType} task={task} />
        default:
            return null
    }
}
